import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/components/shadcn/avatar';
import { cn } from '@/lib/utils';

export default function UserAvatar({
  username,
  imgSrc,
  className,
  imgClassName,
  avatarClassName,
}: {
  username: string;
  imgSrc: string;
  className?: string;
  imgClassName?: string;
  avatarClassName?: string;
}) {
  return (
    <Avatar
      className={`h-10 w-10 cursor-pointer hover:opacity-80 ${className ?? ''}`}
    >
      <AvatarImage src={imgSrc} alt='' className={imgClassName} />
      <AvatarFallback
        className={cn(
          'bg-accent-orange text-base font-normal text-grant-500',
          avatarClassName
        )}
      >
        {username[0].toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
}
